<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>代理管理</el-breadcrumb-item>
        <el-breadcrumb-item>卡密记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>

          <el-button v-if="eggUnlocked" type="danger" size="small" icon="el-icon-delete" :disabled="selectedRows.length === 0" style="margin-left: 10px;" :loading="state" @click="handleBatchDelete">
            批量删除 (已选 {{ selectedRows.length }} 条)
          </el-button>
        </el-card>
      </div>
      
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" ref="agentRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理人邮箱 " prop="cardPassword">
          <el-input v-model="queryInfo.agentEmail"  clearable placeholder="支持模糊查询" @input="changeInput($event)"></el-input>
        </el-form-item>
        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>
      
      <el-table :data="integralData" border style="width: 100%" stripe v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column v-if="eggUnlocked" type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="softName" label="代理软件" width="220"></el-table-column>
        <el-table-column prop="email" label="代理人" width="220"></el-table-column>
        <el-table-column prop="action" label="动作" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '续费'" style="color: #ad6800">续费</span>
            <span v-if="scope.row.action === '删卡'" style="color: #d80821">删卡</span>
            <span v-if="scope.row.action === '提卡'" style="color: #237804">提卡</span>
            <span v-if="scope.row.action === '多开转换'" style="color: #B28B67">多开转换</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" width="80"></el-table-column>
        <el-table-column prop="cardType" label="卡类" width="160"></el-table-column>
        <el-table-column prop="integral" label="积分变动" width="100"></el-table-column>
        <el-table-column prop="record" label="卡密记录">
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover" popper-class="my-popover">
              <code>
                <div v-if="Array.isArray(scope.row.record)">
                  <span class="code-span" v-for="item in scope.row.record" :key="item" style="margin-left:20px;margin-right:20px">{{item}}</span>
                </div>
                <div v-if="Object.prototype.toString.call(scope.row.record) === '[object Object]'">
                  <span class="code-span">{</span>
                  <span class="code-span" v-for="(item,index) in scope.row.record" :key="index" style="margin-left:20px;margin-right:20px">{{index}}: {{item}}</span>
                  <span class="code-span">}</span>
                </div>
                <div v-if="typeof(scope.row.record)=='string'">
                  <span class="code-span" style="margin-left:20px;margin-right:20px">{{scope.row.record}}</span>
                </div>
              </code>
              <div class="text-record" slot="reference" v-if="scope.row.record">{{ scope.row.record | capitalize }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="时间" width="165"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data(){
    return{
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      total:0,
      integralData:[],
      state:false,
      searchForm:{},
      allSoftName:"",
      loading:true,

      eggUnlocked: false,
      selectedRows: [],
      konamiCode: [
        'ArrowUp', 'ArrowUp', 
        'ArrowDown', 'ArrowDown', 
        'ArrowLeft', 'ArrowRight', 
        'ArrowLeft', 'ArrowRight'
      ], // 彩蛋按键序列：上上下下左左右右
      konamiIndex: 0 // 当前匹配到的按键序号
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getIntegralLog()
  },
  mounted() {
    // 监听全局键盘按下事件
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    // 组件销毁前移除监听，防止内存泄漏
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods:{
    // 监听键盘按键匹配彩蛋
    handleKeyDown(event) {
      console.log('当前按下的按键:', event.key);
      // 避免在输入框中输入时误触发
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        return;
      }
      // 将按下的有效按键收集到一个数组中（只保留最后 8 位）
      if (!this.pressedKeys) {
        this.pressedKeys = [];
      }
      this.pressedKeys.push(event.key);
      // 如果长度超过了彩蛋序列长度，截取最后几位
      if (this.pressedKeys.length > this.konamiCode.length) {
        this.pressedKeys.shift();
      }
      // 检查当前按键历史是否和秘籍完全一致
      const isMatched = this.konamiCode.every(
        (key, index) => key === this.pressedKeys[index]
      );
      console.log("isMatched=",isMatched);
      if (isMatched) {
        console.log('彩蛋触发！');
        this.triggerEasterEgg();
        this.pressedKeys = []; // 触发后清空，避免重复触发
      }
    },
    // 触发彩蛋效果
    triggerEasterEgg() {
      if (this.eggUnlocked) return;
      this.eggUnlocked = true;
      this.$notify({
        title: '🎉 隐藏彩蛋已解锁！',
        message: '高能模式开启：已开启日志批量删除功能。',
        type: 'success',
        duration: 4000
      });
    },

    // 监听表格勾选变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    // 批量删除选中的数据
    async handleBatchDelete() {
      // console.log('选中的数据:', this.selectedRows);
      if (this.selectedRows.length === 0) return;
      const ids = this.selectedRows.map(item => item._id);
      // console.log('选中的数据ids:', ids);
      this.state = true;
      const result = await this.$http.post('deleteauthcardlogs', { ids });
      // console.log("result=",result);
      if (result.data.meta.status !== 200) {
        this.$notify.error({ title: '删除失败', message: result.data.meta.msg });
        this.state = false;
        return;
      }else{
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.state = false;
        this.selectedRows = []
        this.getIntegralLog();
      }
    },

    async getIntegralLog(){
      console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("getauthemaicardpasswordllog",{
        params:this.queryInfo
      });
      console.log(result);
      if(result.data.data.data){
        this.integralData = result.data.data.data.map(element => {
          if(element.record.indexOf('{') > -1){
            element.record = JSON.parse(element.record)
          }else if(element.record.indexOf('[') > -1){
            element.record = JSON.parse(element.record)
          }
          return element
        })
      }else{
        this.integralData = []
      }
      this.total = result.data.data.total
      this.loading = false
      this.state = false
      // this.integralData = result.data.data.data
      // this.total = result.data.data.total
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {email:this.$store.state.account});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getIntegralLog()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getIntegralLog()
    },
    refresh(){
      this.queryInfo.pagenum = 1
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.getIntegralLog()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getIntegralLog()
    },
    reSet(){
      this.queryInfo.pagenum = 1
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.getIntegralLog()
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
  filters:{
    capitalize(value){
      if(Array.isArray(value)){
        value = value.toString()
        value = value.replace('[','')
        value = value.replace(']','')
      }
      return value
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-table{
    .text-record{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
}
</style>